import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Button, FormControlLabel, Grid, Paper, Switch,
         Tab, Tabs, TableContainer, Table, TableBody, TableCell, TableHead, TableRow,
         TextField, Tooltip, Typography
} from '@mui/material';
import Add from '@mui/icons-material/Add';
import Article from '@mui/icons-material/Article';
import Business from '@mui/icons-material/Business';
import Contacts from '@mui/icons-material/Contacts';
import ImportExport from '@mui/icons-material/ImportExport';
import Edit from '@mui/icons-material/Edit';
import Person from '@mui/icons-material/Person';
import PauseCircleFilled from '@mui/icons-material/PauseCircleFilled';
import CheckCircle from '@mui/icons-material/CheckCircle';


import AccountUpdateMutation from '../account/AccountUpdateMutation';
import UserUpdateMutation from '../account/UserUpdateMutation';
import PageTitle from '../ui/PageTitle';
import LoadingSpinner from '../ui/LoadingSpinner';
import SavingSpinner from '../ui/SavingSpinner'
import ServerError from '../ui/ServerError';
//import PhoneNumberFormat from '../ui/PhoneNumberFormat';
import Address from '../ui/Address'
import AppBindStyles from '../../AppBindStyles';
import SettingsIntegrations from './SettingsIntegrations';
import Plans from './Plans';

import { green, red } from '@mui/material/colors';

const abEnvironment = new AbEnvironment();
const SettingsLookupQuery = graphql`
query SettingsLookupQuery($accountId: UUID!) {
  accountTByAccountId(accountId: $accountId) {
    accountId
    parentId
    accountType
    accountStatus
    accountNum
    accountName
    logo
    description
    contactLastName
    contactFirstName
    contactEmail
    contactPhone
    address1
    address2
    city
    state
    country
    postalCode
    stripeCid
    dwollaCid
    achActive
    invoiceInformation
    userTsByAccountId(first: 20) {
      totalCount
      nodes {
        userId
        userName
        userRole
        lastName
        firstName
        email
        phone
        address1
        address2
        city
        state
        country
        postalCode
        marqetaUid
        userStatus
      }
    }
    businessIdentityTsByAccountId {
      totalCount
      nodes {
        biId
      }
    }
    accountDelegatedAuthsTsByAccountId {
      totalCount
    }
  }
}
`;

const styleSheet = theme => ({
  tabroot: {
    flexGrow: 1,
    margin: 10,
    width: 'auto',
    borderBottom: '2px solid #dedede',
  },
  tabScrollButton:{
    flex: '0 0 0px'
  },
  flex: {
    flex: 1,
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: 'left',
    // color: theme.palette.text.secondary,
    maxWidth: 1200,
  },
  paper2: {
    padding: 12,
    textAlign: 'left',
    // color: theme.palette.text.secondary,
  },
  accountLogo: {
    float: 'left',
    marginRight: 15
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: 'theme.spacing(1)',
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  statusdiv: {
    display: 'flex',
    alignItems: 'center',
    direction: 'row',
    justify: 'center',
  },
  statusicon: {
    width: 52,
    height: 52,
    color: 'green',
  },
  erroricon: {
    width: 52,
    height: 52,
    color: 'red',
  },
  input: {
    display: 'none',
  },
  button: {
    //margin: theme.spacing(1),
    width: 52,
  },
  iconbutton: {
    width: 100,
    height: 34,
    marginRight: 20,
  },
  addicon: {
    width: 15,
    height: 22,
  },
  editicon: {
    width: 22,
    height: 22,
  },

  /* Hidden below is sort of a hack.  Without overflow hidden - scroll bars appear but were not revealing 
  more data.  It was not obvious what is causing it.  Needs more research */

  /* Screen size specific styles */
  [theme.breakpoints.up('xs')]: {
    tabContainer: {
      padding: 5,
      overflow: 'hidden'
    },
    tableCellPadding: {
      paddingLeft: `6px`,
      paddingRight: `14px`,
    },
    tab: {
      fontSize: 'xx-small',
    },
    labelContainer: {
      paddingLeft: 4,
      paddingRight: 4,
    },
    label: {
      fontSize: 'xx-small',
    },
    labelWrapped: {
      fontSize: 'xx-small',
    },
    tabIcon: {
      fontSize: 24,
    }
  },
  [theme.breakpoints.up('sm')]: {
    tabContainer: {
      padding: 10,
      overflow: 'hidden'
    },
    tableCellPadding: {
      paddingLeft: `12px`,
      paddingRight: `28px`,
    },
    tab: {
      fontSize: 'x-small',
    },
    labelContainer: {
      paddingLeft: 8,
      paddingRight: 8,
    },
    label: {
      fontSize: 'x-small',
    },
    labelWrapped: {
      fontSize: 'x-small',
    },
    tabIcon: {
      fontSize: 24,
    }
  },
  [theme.breakpoints.up('md')]: {
    tabContainer: {
      padding: 20,
      overflow: 'hidden'
    },
    tableCellPadding: {
      paddingLeft: `24px`,
      paddingRight: `56px`,
    },
    tab: {
      fontSize: '0.75rem',
    },
    labelContainer: {
      paddingLeft: 12,
      paddingRight: 12,
    },
    label: {
      fontSize: '0.75rem',
    },
    labelWrapped: {
      fontSize: '0.75rem',
    },
    tabIcon: {
      fontSize: 24,
    }
  },

  tblHead: {
    backgroundColor: '#f1f1f1'
  },
});

function TabContainer(props) {
  const classes = props.classes;
  return <div className={classes.tabContainer}>{props.children}</div>;
}

class Settings extends Component {

  constructor(props) {
    super(props);

    this.state = {
      showSpinner: false,
      value: 0,
      accountId: null,
      accountName: null,
      firstName: null,
      lastName: null,
      email: null,
      phone: null,
      address1: null,
      address2: null,
      city: null,
      state: null,
      country: null,
      postalCode: null,
      stripeCid: null,
      userId: null,
      userName: null,
      uLastName: null,
      uFirstName: null,
      uEmail: null,
      uPhone: null,
      uAddress1: null,
      uAddress2: null,
      uCity: null,
      uState: null,
      uCountry: null,
      uPostalCode: null,
      marqetaUid: null,
      invoiceInformation: null,
      showInactiveUsers: 0,
      imgHeightOrWidth: 'height'
    }
    this.onImgLoad = this.onImgLoad.bind(this);
  }

  componentDidMount() {

    // Is there something in local storage?
    let theValue = 0;
    let tabval = localStorage.getItem('settingsTabVal');
    if (tabval !== null) {
      theValue = parseInt(tabval, 10);
    }

    this.setState({value: theValue});
  }

  handleChange = event => {
    this.setState({ name: event.target.value });
  };

  handleTabChange = (event, value) => {
    this.setState({ value });
    localStorage.setItem('settingsTabVal', value);
  }

  goToUserCreate(route, address) {
    //this defaults the address to company address (see UserCreate.js)
    localStorage.setItem('userCreateParamProps', JSON.stringify(address));
    this.props.history.push(`/${route}`);
  }

  goTo(route) {
    this.props.history.push(`/${route}`);
  }

  getValueForRender(state_member, prop_member, theDefault)
  {
    if (state_member != null)
      return state_member;

    if (prop_member != null)
      return prop_member;

    return theDefault;
  }

  disableSelfSave(userProps) {
    if (userProps === null)
      return true;

    let retval = this.disableAttributeCheck(this.state.uFirstName,  userProps.firstName) &&
                 this.disableAttributeCheck(this.state.uLastName,   userProps.lastName) &&
                 this.disableAttributeCheck(this.state.uEmail,      userProps.email) &&
                 //this.disableAttributeCheck(this.state.uPhone,      userProps.phone) &&
                 this.disableAttributeCheck(this.state.uAddress1,   userProps.address1) &&
                 this.disableAttributeCheck(this.state.uAddress2,   userProps.address2) &&
                 this.disableAttributeCheck(this.state.uCity,       userProps.city) &&
                 this.disableAttributeCheck(this.state.uState,      userProps.state) &&
                 this.disableAttributeCheck(this.state.uCountry,    userProps.country) &&
                 this.disableAttributeCheck(this.state.uPostalCode, userProps.postalCode);

    return retval;
  }

  disableAccountSave(accountProps) {
    if (accountProps === null)
      return true;

    // disableAttributeCheck returns false if something is ready to save.  So if anything is
    // ready to save, retval will be false.
    let retval = this.disableAttributeCheck(this.state.accountName,  accountProps.accountName, false) &&
                 this.disableAttributeCheck(this.state.firstName,    accountProps.contactFirstName, false) &&
                 this.disableAttributeCheck(this.state.lastName,     accountProps.contactLastName, false) &&
                 this.disableAttributeCheck(this.state.email,        accountProps.contactEmail, false) &&
                 //this.disableAttributeCheck(this.state.phone,      accountProps.contactPhone) &&
                 this.disableAttributeCheck(this.state.address1,     accountProps.address1, false) &&
                 this.disableAttributeCheck(this.state.address2,     accountProps.address2, true) &&
                 this.disableAttributeCheck(this.state.city,         accountProps.city, false) &&
                 this.disableAttributeCheck(this.state.state,        accountProps.state, false) &&
                 this.disableAttributeCheck(this.state.country,      accountProps.country, false) &&
                 this.disableAttributeCheck(this.state.postalCode,   accountProps.postalCode, false) &&
                 this.disableAttributeCheck(this.state.invoiceInformation, accountProps.invoiceInformation, true);

    // false means ok to save, but check on address
    if (!retval) {
      //make sure if the old address was present, user did not blank it out.
      if (accountProps.address1) {
        if (this.state.address1 === '') {
          return true;
        }
        if (this.state.city === '') {
          return true;
        }
        if (this.state.state === '') {
          return true;
        }
        if (this.state.postalCode === '') {
          return true;
        }
        if (this.state.country === '') {
          return true;
        }
      }
    }

    /*
    if (retval) {
      //address 2 is special and they are allowed to blank out.
      if (this.state.address2 === '' && (accountProps.address2 !== null && accountProps.address2 !== '')) {
        return false;
      }
    }
    */

    return retval;
  }

  /*
   * The attribute isn't ready for saving unless something
   * has changed.  
   * 
   * A return of false means something has changed (don't disable).
   * 
   */
  disableAttributeCheck(stateVar, propsVar, allowEmptyString)
  {
      if (stateVar !== null)
      {
          if (propsVar === null && stateVar === '')
              return true;

          if ((propsVar !== null && propsVar !== '') && stateVar === '') {
            if (allowEmptyString) {
              return false;
            } else {
              return true;
            }
          }

          if (propsVar !== stateVar)
              return false;
      }
      return true;
  }

  showSpinner() {
    return this.state.showSpinner;
  }

  setCountry    = (country)    => { this.setState({country:    country}); }  
  setRegion     = (region)     => { this.setState({state:      region}); }  
  setCity       = (city)       => { this.setState({city:       city}); }  
  setPostalCode = (postalCode) => { this.setState({postalCode: postalCode}); }  
  setAddress1   = (address1)   => { this.setState({address1:   address1}); }  
  setAddress2   = (address2)   => { this.setState({address2:   address2}); }  

  setUCountry    = (country)    => { this.setState({uCountry:    country}); }  
  setURegion     = (region)     => { this.setState({uState:      region}); }  
  setUCity       = (city)       => { this.setState({uCity:       city}); }  
  setUPostalCode = (postalCode) => { this.setState({uPostalCode: postalCode}); }  
  setUAddress1   = (address1)   => { this.setState({uAddress1:   address1}); }  
  setUAddress2   = (address2)   => { this.setState({uAddress2:   address2}); }  

  goToVerifyBusiness = (biId, props) => {
    let url = '';
    if (biId) {
      if (props.accountTByAccountId.dwollaCid) {
        url = 'businessidentityedit?biId=' + biId + '&dId=' + props.accountTByAccountId.dwollaCid;
      } else {
        url = 'businessidentityedit?biId=' + biId;
      }
    } else {
      //since they are creating, pass as much as we can
      localStorage.setItem('tempVBParm', JSON.stringify(props));
      if (props.accountTByAccountId.dwollaCid) {
        url = 'businessidentitycreate?dId=' + props.accountTByAccountId.dwollaCid;
      } else {
        url = 'businessidentitycreate'
      }
    }
    this.props.history.push(`/${url}`);

  }

  handleFileUpload = event => {
    const { callPartnerApi } = this.props.auth;

    // file upload needs to do something.
    let acctId = abEnvironment.getUserAttribute('a_id');
    let masqueradeAccountId = null;
    if (abEnvironment.isMasquerade()) {
      masqueradeAccountId = localStorage.getItem('m_a_id');
    }

    let theFile = event.target.files[0];
    if (!theFile) {
      return;
    }
    let theFilename = theFile.name;
    let theFiletype = theFile.type;
    let theFilesize = theFile.size;
    // alert('The file size is ' + theFilesize);
    if (theFilesize > 200000) {
      return;
    }

    // Call 
    let payload = {
      operation: "getSignedLogoUploadUrl",
      params: {
        filename: theFilename,
        filetype: theFiletype,
        masqAccountId: masqueradeAccountId
      }
    }
    
    callPartnerApi('appbind/generic',
                   'POST',
                   payload)
    .then((resp) => {
      return resp.json();
    })
    .then(theresp => {
      let theurl = theresp.data;
      return fetch(theurl, {
        method: 'PUT',
        headers: new Headers({
          'Content-Type': theFiletype,
        }),
        body: theFile
      });
    })
    .then(response => {
      // Call an update mutation to set on the account? Probably.
      // The file is being put in logoc/<aid>/fname - so set that on the account
      let theLogoPath = '/logoc/' + acctId + '/' + theFilename;
      return AccountUpdateMutation.commit(acctId, null, null, null, null,
                                          null, null, null, null,
                                          null, null, null, null, null, null,
                                          theLogoPath, null, null, null, null,
                                          null, null, null);

    })
    .then(mr => {
      // console.log(mr);
    })
    .catch(error => {
      // Notify that there was an error
      // console.log(error);
    });

  }

  isAccountPendingOrSuspended(status) {
    if (status === 1 || status === 2) {
      return true;
    } else {
      return false;
    }

  }

  onImgLoad({target:img}) {
    if (img.offsetHeight > img.offsetWidth) {
      if (this.state.imgHeightOrWidth !== 'height') {
        this.setState({imgHeightOrWidth: 'height'});
      }
    } else if (img.offsetHeight < img.offsetWidth) {
      if (this.state.imgHeightOrWidth !== 'width') {
        this.setState({imgHeightOrWidth: 'width'});
      }
    } 
  }

  render() {
    const { validateEmail, isAuthenticated, isUnauthenticatedCustomer, isAuthenticatedCustomer, isAuthenticatedReseller, isAuthenticatedVendor, isAdminUser, needAssent, logError } = this.props.auth;
    const classes = this.props.classes;
    const { value } = this.state;

    // Integrations feature flag
    // - in April 2022, moving to integrationsFB, integrationsQBO, integrationsXero, integrationsCustom
    //
    let integrations = false;

    // Integrations feature flags for various integrations
    // - Reseller integrations
    let integrationsFB   = false;
    let integrationsQBO  = false;
    let integrationsXero = false;
    let integrationsCustom = false;
    // - Vendor integrations
    let integrationsRecurly = false;

    let integrationsFbFlag = abEnvironment.getFlagValue("integrationsFB");
    if (integrationsFbFlag != null && integrationsFbFlag.flagValue === 1) { integrationsFB = true; }
    // integrationsFB = true;  // TODO - remove this line before prod release until ready to fully turn on.

    let integrationsQboFlag = abEnvironment.getFlagValue("integrationsQBO");
    if (integrationsQboFlag  != null && integrationsQboFlag.flagValue === 1)  { integrationsQBO = true; }

    let integrationsXeroFlag = abEnvironment.getFlagValue("integrationsXero");
    if (integrationsXeroFlag != null && integrationsXeroFlag.flagValue === 1) { integrationsXero = true; }

    let integrationsCustomFlag = abEnvironment.getFlagValue("integrationsCustom");
    if (integrationsCustomFlag != null && integrationsCustomFlag.flagValue === 1) { integrationsCustom = true; }

    if (isAuthenticatedReseller() && (integrationsFB || integrationsQBO || integrationsXero || integrationsCustom))
    {
      integrations = true;
    }

    if (isAuthenticatedCustomer() && integrationsQBO) {
      integrations = true;
    }

    let integrationsRecurlyFlag = abEnvironment.getFlagValue("integrationsRecurly");
    if (integrationsRecurlyFlag != null && integrationsRecurlyFlag.flagValue === 1) { integrationsRecurly = true; }

    if (isAuthenticatedVendor() && (integrationsRecurly || integrationsCustom)) {
      integrations = true;
    }

    const statusOk = green[300];
    const statusPause = red[300];

    // Experiences for different personas...
    if (!isAuthenticated() || needAssent() || isUnauthenticatedCustomer()) {
      return (
        <Redirect to='/home' />
      );
    } else {
      let acctId = abEnvironment.getUserAttribute('a_id');
      let uid = abEnvironment.getUserAttribute('u_id');

      let isAdmin = isAdminUser();

      let showInvite = true;

      let emailError = false;
      if (this.state.email != null && this.state.email !== '') {
        let emailOk = validateEmail(this.state.email);
        if (! emailOk) {
          emailError = true;
        }
      }
      let uEmailError = false;
      if (this.state.uEmail != null && this.state.uEmail !== '') {
        let emailOk = validateEmail(this.state.uEmail);
        if (! emailOk) {
          uEmailError = true;
        }
      }                      

      return (
        <QueryRenderer
          environment={abEnvironment.getEnvironment()}
          query={SettingsLookupQuery}
          variables={{accountId: acctId}}
          render={({error, props})=> {
            if (error) {
              logError(error.message);
              return (
                <ServerError/>
              );
            } else if (props) {
              // Determine current user
              let currentUser = null;
              let cuIdx = null;
              for (var i=0; i<props.accountTByAccountId.userTsByAccountId.nodes.length; i++)
              {
                let tu = props.accountTByAccountId.userTsByAccountId.nodes[i];
                if (tu.userId === uid)
                {
                  currentUser = tu;
                  cuIdx = i;
                }
              }

              if (currentUser == null) {
                showInvite = false;
              }

              let regionLabel = "Region";
              let address = {
                country:    this.getValueForRender(this.state.country,    props.accountTByAccountId.country,    ''),
                state:      this.getValueForRender(this.state.state,      props.accountTByAccountId.state,      ''),
                city:       this.getValueForRender(this.state.city,       props.accountTByAccountId.city,       ''),
                postalCode: this.getValueForRender(this.state.postalCode, props.accountTByAccountId.postalCode, ''),
                address1:   this.getValueForRender(this.state.address1,   props.accountTByAccountId.address1,   ''),
                address2:   this.getValueForRender(this.state.address2,   props.accountTByAccountId.address2,   '')
              };

              let uRegionLabel = "Region";
              let uAddress = null;
              if (currentUser != null) {
                uAddress = {
                  country:    this.getValueForRender(this.state.uCountry,    currentUser.country,    ''),
                  state:      this.getValueForRender(this.state.uState,      currentUser.state,      ''),
                  city:       this.getValueForRender(this.state.uCity,       currentUser.city,       ''),
                  postalCode: this.getValueForRender(this.state.uPostalCode, currentUser.postalCode, ''),
                  address1:   this.getValueForRender(this.state.uAddress1,   currentUser.address1,   ''),
                  address2:   this.getValueForRender(this.state.uAddress2,   currentUser.address2,   '')
                };
              }

              let biId = null;
              if (props.accountTByAccountId.businessIdentityTsByAccountId.totalCount !== 0) {
                //assign the previously entered business identify key
                biId = props.accountTByAccountId.businessIdentityTsByAccountId.nodes[0].biId
              }

              // Check if there are any integrations already provisioned.  If so, set integrations on.
              if (props.accountTByAccountId.accountDelegatedAuthsTsByAccountId.totalCount > 0) {
                integrations = true;
              }

              let showPlans = false;
              let showPlansFlag = abEnvironment.getFlagValue("showPlans");
              if (showPlansFlag != null && showPlansFlag.flagValue === 1) {
                showPlans = true;
              }

              if (props.accountTByAccountId == null) {
                return (
                  <Paper className={classes.paper2}>
                    <Typography variant="h6" className={classes.flex}>
                      Unable to load settings
                    </Typography>
                  </Paper>
                );
              }
          
              return (
                <Grid container spacing={2} direction="row" justifyContent="flex-start">
                  <Grid item xs={12}>
                    <Grid container spacing={1} direction="row" justifyContent="flex-start" alignItems="flex-start">
                      <Grid item>
                        { props.accountTByAccountId.logo != null &&
                        <div>
                          <input
                            accept="image/*"
                            className={classes.input}
                            id="upload-button"
                            type="file"
                            onChange={this.handleFileUpload}
                          />
                          <Tooltip title="Click to change logo">
                            <label htmlFor="upload-button">
                              <Button variant="text" component="span" className={classes.button}>
                                {this.state.imgHeightOrWidth === 'width' &&
                                  <img alt="Logo" width="52px" onLoad={this.onImgLoad} src={props.accountTByAccountId.logo} />
                                }
                                {this.state.imgHeightOrWidth === 'height' &&
                                  <img alt="Logo" height="52px" onLoad={this.onImgLoad} src={props.accountTByAccountId.logo} />
                                }
                              </Button>
                            </label>
                          </Tooltip>
                        </div>}

                        { props.accountTByAccountId.logo == null &&
                        <div>
                          <input
                            accept="image/*"
                            className={classes.input}
                            id="upload-button"
                            type="file"
                            onChange={this.handleFileUpload}
                          />
                          <Tooltip title="Click to add logo">
                            <label htmlFor="upload-button">
                              <Button variant="outlined" component="span" className={classes.button}>
                                <img alt="Logo" height="48px" src={'/logos/add-logo-225.png'} />
                              </Button>
                            </label>
                          </Tooltip>
                        </div>}
                      </Grid>
                      <Grid item>
                        <PageTitle title={props.accountTByAccountId.accountName} subtitle="Tell us about yourself." noMargin={true}/>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={12}>
                    <Paper className={classes.paper}>
                      <Grid container spacing={0} direction="row" justifyContent="space-around">
                        <Grid item xs={12}>
                          <Tabs
                            value={value}
                            onChange={this.handleTabChange}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="fullWidth"
                            scrollButtons="auto"
                            classes={{root: classes.tabroot, scrollButtons: classes.tabScrollButton}}
                          >
                            <Tab label="My information"
                              icon={<Person className={classes.tabIcon} />}
                              classes={{
                                  root: classes.tab,
                                  wrapper: classes.labelWrapped,
                                }}/>
                            <Tab label="Company information"
                              icon={<Business className={classes.tabIcon} />}
                              classes={{
                                  root: classes.tab,
                                  wrapper: classes.labelWrapped,
                                }}/>
                            <Tab label="Company users"
                              icon={<Contacts className={classes.tabIcon} />}
                              classes={{
                                  root: classes.tab,
                                  wrapper: classes.labelWrapped,
                                }}/>
                            {showPlans && 
                            <Tab label="Plans"
                              icon={<Article className={classes.tabIcon} />}
                              classes={{
                                  root: classes.tab,
                                  wrapper: classes.labelWrapped,
                                }}/>
                            }
                            { integrations === true &&
                            <Tab label="Integrations"
                              icon={<ImportExport className={classes.tabIcon} />}
                              classes={{
                                  root: classes.tab,
                                  wrapper: classes.labelWrapped,
                                }}/>
                            }
                          </Tabs>
                        </Grid>

                        <Grid item xs={12}>
                          {value === 0 && currentUser == null &&
                          <TabContainer {...this.props}>
                            No current user
                          </TabContainer>
                          }
                          {value === 0 && currentUser != null &&
                          <TabContainer {...this.props}>
                            <Grid container spacing={2} justifyContent="space-between">
                              <Grid item xs={12}>
                                <Typography variant="h6" style={AppBindStyles.sectionTitleFirst}>
                                  Contact
                                </Typography>
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <TextField data-recording-ignore="mask"
                                  id="ufirst-name" label="First name"
                                  value={ this.getValueForRender(this.state.uFirstName,
                                          currentUser.firstName,
                                          '') }
                                  onChange={ (e) => this.setState({ uFirstName: e.target.value }) }
                                  inputProps={{ maxLength: 32 }}
                                />
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <TextField data-recording-ignore="mask"
                                  id="ulast-name" label="Last name"
                                  value={ this.getValueForRender(this.state.uLastName,
                                          currentUser.lastName,
                                          '') }
                                  onChange={ (e) => this.setState({ uLastName: e.target.value }) }
                                  inputProps={{ maxLength: 32 }}
                                />
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <TextField data-recording-ignore="mask"
                                  id="uEmail" label="Email"
                                  error={uEmailError}
                                  value={ this.getValueForRender(this.state.uEmail,
                                          currentUser.email,
                                          '') }
                                  type='email'
                                  InputProps={{ readOnly: true, disableUnderline: true }}
                                />
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                  {/* remove this grid item when we bring phone number back */}
                              </Grid>
                              {/*<Grid item xs={12} sm={6}>
                                <TextField data-recording-ignore="mask"
                                  id="uphone" label="Phone"
                                  value={ this.getValueForRender(this.state.uPhone,
                                          currentUser.phone,
                                          '') }
                                  onChange={ (e) => this.setState({ uPhone: e.target.value }) }
                                  InputProps={{
                                    inputComponent: PhoneNumberFormat,
                                    classes: { input: classes.inputFontSize }
                                  }}
                                />
                                </Grid>*/}
                              <Grid item xs={12}>
                                <Typography variant="h6" style={AppBindStyles.sectionTitle}>
                                  Mailing address
                                </Typography>
                              </Grid>
                              <Grid item xs={12}>
                                <Address
                                  address={uAddress}
                                  regionLabel={uRegionLabel}
                                  setCountryCodeState={this.setUCountry}
                                  setRegionCodeState={this.setURegion}
                                  setCityState={this.setUCity}
                                  setPostalCodeState={this.setUPostalCode}
                                  setAddress1State={this.setUAddress1}
                                  setAddress2State={this.setUAddress2}
                                />
                              </Grid>
                            </Grid>

                            <Grid container spacing={3} direction="row" justifyContent="flex-start">
                              <Grid item xs={1}>
                                { !this.showSpinner() &&
                                  <Button disabled={this.disableSelfSave(currentUser)} variant="contained" color="primary"  style={AppBindStyles.bottomButton}
                                    onClick={() => {this._updateUser(uid, acctId, cuIdx); }}>
                                    Save
                                  </Button>
                                }
                                {this.showSpinner() &&
                                <Button color="primary" variant="contained" style={AppBindStyles.bottomButton}>
                                  <SavingSpinner/>
                                </Button>
                                }
                              </Grid>
                            </Grid>
                          </TabContainer>
                          }
                          {value === 1 &&
                          <TabContainer {...this.props}>
                            <Grid container spacing={2} justifyContent="flex-start">
                              <Grid item xs={12}>
                                <Typography variant="h6" style={AppBindStyles.sectionTitleFirst}>
                                  Account
                                </Typography>
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <TextField
                                  id="accountName" label="Account name"
                                  value={ this.getValueForRender(this.state.accountName,
                                          props.accountTByAccountId.accountName,
                                          '') }
                                  onChange={ (e) => this.setState({ accountName: e.target.value }) }
                                  inputProps={{ maxLength: 64 }}
                                />
                              </Grid>
                            </Grid>
                            <Grid container spacing={2} justifyContent="space-around">
                              <Grid item xs={12}>
                                <Typography variant="h6" style={AppBindStyles.sectionTitle}>
                                  Primary contact
                                </Typography>
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <TextField data-recording-ignore="mask"
                                  id="first-name" label="Contact first name"
                                  value={ this.getValueForRender(this.state.firstName,
                                          props.accountTByAccountId.contactFirstName,
                                          '') }
                                  onChange={ (e) => this.setState({ firstName: e.target.value }) }
                                  inputProps={{ maxLength: 32 }}
                                />
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <TextField data-recording-ignore="mask"
                                  id="last-name" label="Contact last name"
                                  value={ this.getValueForRender(this.state.lastName,
                                          props.accountTByAccountId.contactLastName,
                                          '') }
                                  onChange={ (e) => this.setState({ lastName: e.target.value }) }
                                  inputProps={{ maxLength: 32 }}
                                />
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <TextField data-recording-ignore="mask"
                                  id="email" label="Contact email"
                                  error={emailError}
                                  value={ this.getValueForRender(this.state.email,
                                          props.accountTByAccountId.contactEmail,
                                          '') }
                                  type='email'
                                  onChange={ (e) => this.setState({ email: e.target.value }) }
                                  inputProps={{ maxLength: 254 }}
                                />
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                  {/* remove this grid item when we bring phone number back */}
                              </Grid>
                              {/*<Grid item xs={12} sm={6}>
                                <TextField data-recording-ignore="mask"
                                    id="phone" label="Contact phone"
                                    value={ this.getValueForRender(this.state.phone,
                                      props.accountTByAccountId.contactPhone,
                                            '') }
                                    onChange={ (e) => this.setState({ phone: e.target.value }) }
                                    InputProps={{
                                      inputComponent: PhoneNumberFormat,
                                      classes: { input: classes.inputFontSize }
                                    }}
                                />
                              </Grid>*/}
                              <Grid item xs={12}>
                                <Typography variant="h6" style={AppBindStyles.sectionTitle}>
                                  Mailing address
                                </Typography>
                              </Grid>
                              <Grid item xs={12}>
                                <Address
                                  address={address}
                                  regionLabel={regionLabel}
                                  setCountryCodeState={this.setCountry}
                                  setRegionCodeState={this.setRegion}
                                  setCityState={this.setCity}
                                  setPostalCodeState={this.setPostalCode}
                                  setAddress1State={this.setAddress1}
                                  setAddress2State={this.setAddress2}
                                />
                              </Grid>
                              <Grid item xs={12}>
                                <TextField 
                                    id="invoice-info" label="Bill information"
                                    value={ this.getValueForRender(this.state.invoiceInformation,
                                            props.accountTByAccountId.invoiceInformation,
                                            '') }
                                    multiline
                                    onChange={ (e) => this.setState({ invoiceInformation: e.target.value }) }
                                    inputProps={{ maxLength: 512 }}
                                    helperText={'Enter any information (e.g. VAT, tax id) that should be displayed on bills '}
                                  />
                              </Grid>
                            </Grid>

                              <Grid container spacing={3} direction="row" justifyContent="flex-start">
                                <Grid item >
                                  { !this.showSpinner() &&
                                  <Button disabled={this.disableAccountSave(props.accountTByAccountId)} variant="contained" color="primary"  style={AppBindStyles.bottomButton}
                                    onClick={() => {this._updateAccount(acctId);}}>
                                    Save
                                  </Button> }
                                  {this.showSpinner() &&
                                  <Button color="primary" variant="contained"  style={AppBindStyles.bottomButton} >
                                    <SavingSpinner/>
                                  </Button>
                                  }
                                  { isAdmin  && (props.accountTByAccountId.achActive === 2) &&
                                    <Button variant="outlined" color="primary" style={AppBindStyles.bottomButton} onClick={() => { this.goToVerifyBusiness(biId, props); }}>
                                      Verify Business
                                    </Button>
                                  }
                              </Grid>
                            </Grid>
                          </TabContainer>
                          }
                          { /* User list all inline for now */ }
                          {value === 2 &&
                          <TabContainer {...this.props}>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={this.state.showInactiveUsers === 1}
                                  onChange={(e, checked) => {
                                    if (checked) {
                                      this.setState({ showInactiveUsers: 1});
                                    } else {
                                      this.setState({ showInactiveUsers: 0});
                                    }
                                  }}
                                />
                              }
                              label={'Show inactive users'}
                            />
                            <TableContainer>
                              <Table>
                                <TableHead className={classes.tblHead}>
                                  <TableRow>
                                    <TableCell className={classes.tableCellPadding}>Name</TableCell>
                                    <TableCell className={classes.tableCellPadding}>Email</TableCell>
                                    <TableCell className={classes.tableCellPadding}>Admin</TableCell>
                                    <TableCell className={classes.tableCellPadding}>Active</TableCell>
                                    {showInvite &&
                                    <TableCell className={classes.tableCellPadding}>
                                        <Button
                                        className={classes.iconbutton}
                                        color="primary" variant="outlined"
                                        disabled={!isAdmin || this.isAccountPendingOrSuspended(props.accountTByAccountId.accountStatus)}
                                        onClick={this.goToUserCreate.bind(this, 'usercreate', address)}
                                      >
                                        <Add className={classes.addicon}/>&nbsp;Invite&nbsp;user
                                      </Button>
                                    </TableCell>
                                    }
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {props.accountTByAccountId.userTsByAccountId.nodes.map(n => {
                                    let tlink = 'useredit?userId=' + n.userId;
                                    if (this.state.showInactiveUsers === 0 && n.userStatus !== 0) {
                                      return (null);
                                    }
                                    return (
                                      <TableRow key={n.userId}>
                                        <TableCell className={classes.tableCellPadding} data-recording-sensitive>{n.firstName} {n.lastName}</TableCell>
                                        <TableCell className={classes.tableCellPadding} data-recording-sensitive>{n.email}</TableCell>
                                        <TableCell className={classes.tableCellPadding} >{n.userRole === 0? 'Yes' : 'No'}</TableCell>
                                        {n.userStatus === 0 && 
                                          <TableCell className={classes.tableCellPadding} ><CheckCircle htmlColor={statusOk}/></TableCell>
                                        }
                                          {n.userStatus !== 0 && 
                                          <TableCell className={classes.tableCellPadding} ><PauseCircleFilled htmlColor={statusPause}/></TableCell>
                                        }
                                        {/*<TableCell className={classes.tableCellPadding} data-recording-sensitive><PhoneNumberFormat readOnly={true} value={n.phone}/></TableCell>*/}
                                        {showInvite &&
                                        <TableCell className={classes.tableCellPadding}>
                                          { uid !== n.userId &&
                                          <Button
                                            className={classes.iconbutton}
                                            disabled={!isAdmin}
                                            onClick={this.goTo.bind(this, tlink)}>
                                            <Edit className={classes.editicon}/>
                                          </Button>
                                          }
                                        </TableCell>
                                        }
                                      </TableRow>
                                    );
                                  })}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </TabContainer>
                          }
                          {value === 3 && showPlans &&
                          <TabContainer {...this.props}>
                            <Plans
                              auth={this.props.auth}
                              accountId={props.accountTByAccountId.accountId}
                              history={this.props.history}
                            /> 
                          </TabContainer>
                          }
                          {((value === 4 && showPlans) || (value === 3 && !showPlans)) &&
                          <TabContainer {...this.props}>
                            {/* */}
                            <SettingsIntegrations
                              auth={this.props.auth}
                              history={this.props.history}
                            /> 
                          </TabContainer>
                          }
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>
                </Grid>
              );
            }
            return <div><LoadingSpinner/></div>
          }}
        />
      );
    }
  }

  _updateUser(uid, accountId, cuIdx) {
    this.setState({ showSpinner: true });
    const { uLastName, uFirstName, uEmail, uPhone,
            uAddress1, uAddress2, uCity, uState, uCountry, uPostalCode } = this.state;

    let theAcctString = 'accountTByAccountId(accountId:"' + accountId + '")';
    let theUserString = 'userTsByAccountId(first:20)';

    let storeObj = {
      accountString: theAcctString,
      userString: theUserString,
      userIdx: cuIdx
    };

    UserUpdateMutation.commit(uid,
                              uLastName, uFirstName, uEmail, uPhone,
                              uAddress1, uAddress2, uCity, uState, uCountry, uPostalCode,
                              storeObj)
    .then(response => {
      // console.log('User Update');
      this.setState({ showSpinner: false });
    })
    .catch(error => {
      // console.log('Got error: ' + error);
      this.setState({ showSpinner: false });
    });
  }

  _updateAccount(acctId) {
    this.setState({ showSpinner: true });
    const { accountName, lastName, firstName, email, phone,
            address1, address2, city, state, country, postalCode, invoiceInformation } = this.state;

    AccountUpdateMutation.commit(acctId, accountName, null, null, null,
                                 lastName, firstName, email, phone,
                                 address1, address2, city, state, country, postalCode,
                                 null, null, null, null, null, 
                                 null, invoiceInformation, null)
    .then(response => {
      // console.log('Account updated')
      this.setState({ showSpinner: false });
     
      if (accountName != null)
        abEnvironment.setUserAttribute('a_accountName', accountName);
      if (lastName != null)
        abEnvironment.setUserAttribute('a_lastName', lastName);
      if (firstName != null)
        abEnvironment.setUserAttribute('a_firstName', firstName);
      if (email != null)
        abEnvironment.setUserAttribute('a_email', email);
      if (phone != null)
        abEnvironment.setUserAttribute('a_phone', phone); 
      if (address1 != null)
        abEnvironment.setUserAttribute('a_address1', address1);
      if (address2 != null)
        abEnvironment.setUserAttribute('a_address2', address2);
      if (city != null)
        abEnvironment.setUserAttribute('a_city', city);
      if (state != null)
        abEnvironment.setUserAttribute('a_state', state);
      if (country != null)
        abEnvironment.setUserAttribute('a_country', country);
      if (postalCode != null)
        abEnvironment.setUserAttribute('a_postalCode', postalCode);

     })
    .catch(error => {
      // console.log('Got error: ' + error);
      this.setState({ showSpinner: false });
    });
  }
}

Settings.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(Settings);


/*
                              <Tab label="My Information"
                                icon={<Person className={classes.tabIcon} />}
                                classes={{
                                    root: classes.tab,
                                    label: classes.label,
                                    labelContainer: classes.labelContainer,
                                    labelWrapped: classes.labelWrapped,
                                 }}/>
                              <Tab label="Company Information"
                                icon={<Business className={classes.tabIcon} />}
                                classes={{
                                    root: classes.tab,
                                    label: classes.label,
                                    labelContainer: classes.labelContainer,
                                    labelWrapped: classes.labelWrapped,
                                 }}/>
                              <Tab label="Company Users"
                                icon={<Contacts className={classes.tabIcon} />}
                                classes={{
                                    root: classes.tab,
                                    label: classes.label,
                                    labelContainer: classes.labelContainer,
                                    labelWrapped: classes.labelWrapped,
                                 }}/>

*/